import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'

import BindHome from './views/bind_home';
import inform from './views/inform';
import loading from './views/loading';
import A_fake from './views/A_fake';
import A_BlackList from './views/ABlacklist';
import A_nonactivate from './views/A_nonactivate';
import A_activate from './views/A_activated';
import A_nonrecord from './views/A_nonrecord';
import B_fake from './views/B_fake';
import B_bind from './views/B_bind';
import query_result from './views/query_result';
import scan from './views/scan';
import shipping_mark from './views/shipping_mark';

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'index',
            component: Index,
            redirect: 'home',
            children: [{
                path: '/home',
                name: 'home',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import( /* webpackChunkName: "about" */ './components/Home.vue')
            }, {
                path: '/about',
                name: 'about',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import( /* webpackChunkName: "about" */ './components/About.vue')
            }, {
                path: '/privacy-policy',
                name: 'privacy-policy',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import( /* webpackChunkName: "about" */ './components/PrivacyPolicy.vue')
            }, {
                path: '/terms-of-use',
                name: 'terms-of-use',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import( /* webpackChunkName: "about" */ './components/TermsOfUse.vue')
            }]
        }, {
            path: '/s',
            component: BindHome,
            name: 'bind-home'
        }, {
            path: '/inform',
            component: inform,
            name: 'inform'
        }, {
            path: '/scan',
            component: scan,
            name: 'scan'
        }, {
            path: '/s/:code',
            component: loading,
            name: 'loading'
        }, {
            path: '/query_result',
            component: query_result,
            name: 'query_result',
            children: [{
                path: 'a_fake',
                component: A_fake,
                name: 'A_fake'
            }, {
                path: 'a_black',
                component: A_BlackList,
                name: 'ABlackList'
            }, {
                path: 'a_nonactivate',
                component: A_nonactivate,
                name: 'A_nonactivate'
            }, {
                path: 'a_activate',
                component: A_activate,
                name: 'A_activate'
            }, {
                path: 'a_nonrecord',
                component: A_nonrecord,
                name: 'A_nonrecord'
            }, {
                path: 'b_fake',
                component: B_fake,
                name: 'B_fake'
            }, {
                path: 'b_bind',
                component: B_bind,
                name: 'B_bind'
            }]
        },
        {
            path: '/shipping_mark/:code',
            component: shipping_mark,
            name: 'shipping_mark'
        },
        {
            path: "*",
            redirect: "/"
        }]
})